<template>
  <div
    style="margin-bottom: -40px; padding: 1.25rem"
    v-if="!onload"
  >
    <div
      id="carouselCaptions"
      class="carousel"
      data-ride="carousel"
      data-touch="false"
      data-interval="false"
    >
      <div class="carousel-inner">
        <!-- ====== CountdownChangePassword ====== -->
        <div
          class="carousel-item active"
          v-if="alertCountdownChangePassword"
        >
          <div class="carousel-caption-nas">
            <div
              class="
                alert
                bg-warning
                text-white
                alert-styled-left alert-dismissible
              "
            >
              <span v-if="countDownTimer > 0">{{
                $t("Your password will be expired in") +
                  " " +
                  countDownTimer +
                  " " +
                  $t("days") +
                  $t("please change to ensure the account security")
              }}</span>
              <span v-else>{{
                $t("Your password is expired. Your password must be changed every") +
                  " " +
                  dayExpiration +
                  " " +
                  $t("days") +
                  " " +
                  $t("to ensure the account security")
              }}</span>
              <a
                class="alert-link"
                :href="urlSecurity"
              ><u>{{ $t("Change now") }}</u>
              </a>
              <span
                class="button-next-prev-nas"
                v-if="
                  numPageCountdown +
                    numPageCredit +
                    numPageBankAccount +
                    numPageFlatrate +
                    numAdvanceSalesOrderNotify >
                    1
                "
              >
                <span style="font-size: 13px">
                  <span class="ml-1">{{ numPageCountdown }}</span>
                  <span class="ml-1 mr-1">/</span>
                  <span class="mr-1">{{
                    numPageCountdown +
                      numPageCredit +
                      numPageBankAccount +
                      numPageFlatrate +
                      numAdvanceSalesOrderNotify
                  }}</span>
                  <button
                    class="button-color-nas-next-prev"
                    data-target="#carouselCaptions"
                    data-slide="next"
                  >
                    <span class="fa fa-angle-right" />
                  </button>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- ====== CountdownChangePassword ====== -->
        <!-- ====== ConfirmBusiness ====== -->
        <div
          :class="['carousel-item', numPageCountdown == 0 ? 'active' : '']"
          v-if="alertConfirmBusiness"
        >
          <div class="carousel-caption-nas">
            <div
              class="
                alert
                bg-warning
                text-white
                alert-styled-left alert-dismissible
              "
            >
              {{
                $t(
                  "You haven't verified your business information. so that you can enable various transport"
                )
              }}
              <!-- <router-link to="/app/settings/business-info" class="alert-link"><u>{{$t('คลิ๊กที่นี่เพื่อตั้งค่า')}}</u></router-link> -->
              <router-link
                :to="{
                  name: 't.a.settings',
                  query: { page: 'info' }
                }"
                class="alert-link"
              >
                <u>{{ $t("Click here to setting") }}</u>
              </router-link>
              <span
                class="button-next-prev-nas"
                v-if="
                  numPageCountdown +
                    numPageCredit +
                    numPageBankAccount +
                    numPageFlatrate +
                    numAdvanceSalesOrderNotify >
                    1
                "
              >
                <span style="font-size: 13px">
                  <button
                    class="button-color-nas-next-prev"
                    data-target="#carouselCaptions"
                    data-slide="prev"
                    v-if="numPageCountdown >= 1"
                  >
                    <span class="fa fa-angle-left" />
                  </button>
                  <span class="ml-1">{{
                    numPageCountdown + numPageCredit
                  }}</span>
                  <span class="ml-1 mr-1">/</span>
                  <span class="mr-1">{{
                    numPageCountdown +
                      numPageCredit +
                      numPageBankAccount +
                      numPageFlatrate +
                      numAdvanceSalesOrderNotify
                  }}</span>
                  <button
                    class="button-color-nas-next-prev"
                    data-target="#carouselCaptions"
                    data-slide="next"
                  >
                    <span class="fa fa-angle-right" />
                  </button>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- ====== ConfirmBusiness ====== -->
        <!-- ====== ConfirmBankAccount ====== -->
        <div
          :class="[
            'carousel-item',
            numPageCountdown + numPageCredit == 0 ? 'active' : '',
          ]"
          v-if="alertConfirmBankAccount"
        >
          <div class="carousel-caption-nas">
            <div
              class="
                alert
                bg-warning
                text-white
                alert-styled-left alert-dismissible
              "
            >
              {{ $t("You haven't set up your payment. for correct billing") }}
              <router-link
                :to="{
                  name: 't.a.settings',
                  query: { page: 'payment' }
                }"
                class="alert-link"
              >
                <u>{{ $t("Click here to setting") }}</u>
              </router-link>
              <span
                class="button-next-prev-nas"
                v-if="
                  numPageCountdown +
                    numPageCredit +
                    numPageBankAccount +
                    numPageFlatrate +
                    numAdvanceSalesOrderNotify >
                    1
                "
              >
                <span style="font-size: 13px">
                  <button
                    class="button-color-nas-next-prev"
                    data-target="#carouselCaptions"
                    data-slide="prev"
                    v-if="numPageCountdown + numPageCredit >= 1"
                  >
                    <span class="fa fa-angle-left" />
                  </button>
                  <span class="ml-1">{{
                    numPageCountdown + numPageCredit + numPageBankAccount
                  }}</span>
                  <span class="ml-1 mr-1">/</span>
                  <span class="mr-1">{{
                    numPageCountdown +
                      numPageCredit +
                      numPageBankAccount +
                      numPageFlatrate +
                      numAdvanceSalesOrderNotify
                  }}</span>
                  <button
                    v-if="numPageFlatrate + numAdvanceSalesOrderNotify >= 1"
                    class="button-color-nas-next-prev"
                    data-target="#carouselCaptions"
                    data-slide="next"
                  >
                    <span class="fa fa-angle-right" />
                  </button>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- ====== ConfirmBankAccount ====== -->
        <!-- ====== ConfirmFlatrate ====== -->
        <div
          :class="[
            'carousel-item',
            numPageCountdown + numPageCredit + numPageBankAccount == 0
              ? 'active'
              : '',
          ]"
          v-if="alertConfirmFlatrate"
        >
          <div class="carousel-caption-nas">
            <div
              class="
                alert
                bg-warning
                text-white
                alert-styled-left alert-dismissible
              "
            >
              {{
                $t(
                  "You haven't setting a shipping price. to claim the shipping cost in the order correct"
                )
              }}
              <router-link
                :to="{
                  name: 't.a.settings',
                  query: { page: 'shippingAndDelivery' }
                }"
                class="alert-link"
              >
                <u>{{ $t("Click here to setting") }}</u>
              </router-link>
              <span
                class="button-next-prev-nas"
                v-if="
                  numPageCountdown +
                    numPageCredit +
                    numPageBankAccount +
                    numPageFlatrate +
                    numAdvanceSalesOrderNotify >
                    1
                "
              >
                <span style="font-size: 13px">
                  <button
                    class="button-color-nas-next-prev"
                    data-target="#carouselCaptions"
                    data-slide="prev"
                    v-if="
                      numPageCountdown + numPageCredit + numPageBankAccount >= 1
                    "
                  >
                    <span class="fa fa-angle-left" />
                  </button>
                  <span class="ml-1">{{
                    numPageCountdown +
                      numPageCredit +
                      numPageBankAccount +
                      numPageFlatrate
                  }}</span>
                  <span class="ml-1 mr-1">/</span>
                  <span class="mr-1">{{
                    numPageCountdown +
                      numPageCredit +
                      numPageBankAccount +
                      numPageFlatrate +
                      numAdvanceSalesOrderNotify
                  }}</span>
                  <button
                    v-if="numAdvanceSalesOrderNotify >= 1"
                    class="button-color-nas-next-prev"
                    data-target="#carouselCaptions"
                    data-slide="next"
                  >
                    <span class="fa fa-angle-right" />
                  </button>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- ====== ConfirmFlatrate ====== -->
        <!-- ====== ConfirmAdvanceSalesOrderNotify ====== -->
        <div
          :class="[
            'carousel-item',
            numPageCountdown +
              numPageCredit +
              numPageBankAccount +
              numPageFlatrate ==
              0
              ? 'active'
              : '',
          ]"
          v-if="alertAdvanceSalesOrderNotify"
        >
          <div class="carousel-caption-nas">
            <div
              class="
                alert
                bg-warning
                text-white
                alert-styled-left alert-dismissible
              "
            >
              {{
                $t(
                  "Warning! Your notification has been reset as you upgrade your plan. Please reset your notification."
                )
              }}
              <router-link
                :to="{
                  name: 't.a.settings',
                  query: { page: 'notifyOrder' }
                }"
                class="alert-link"
              >
                <u>{{ $t("Click") }}</u>
              </router-link>
              <span
                class="button-next-prev-nas"
                v-if="
                  numPageCountdown +
                    numPageCredit +
                    numPageBankAccount +
                    numPageFlatrate >=
                    1
                "
              >
                <span style="font-size: 13px">
                  <button
                    class="button-color-nas-next-prev"
                    data-target="#carouselCaptions"
                    data-slide="prev"
                    v-if="
                      numPageCountdown +
                        numPageCredit +
                        numPageBankAccount +
                        numPageFlatrate >=
                        1
                    "
                  >
                    <span class="fa fa-angle-left" />
                  </button>
                  <span class="ml-1">{{
                    numPageCountdown +
                      numPageCredit +
                      numPageBankAccount +
                      numPageFlatrate +
                      numAdvanceSalesOrderNotify
                  }}</span>
                  <span class="ml-1 mr-1">/</span>
                  <span class="mr-1">{{
                    numPageCountdown +
                      numPageCredit +
                      numPageBankAccount +
                      numPageFlatrate +
                      numAdvanceSalesOrderNotify
                  }}</span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <!-- ====== ConfirmAdvanceSalesOrderNotify ====== -->
      </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
export default {
  name: "AlertCustomer",
  data() {
    return {
      urlSecurity: process.env.CENTRAL_ACC_URL + "/security",
      countDownTimer: 0,
      alertCountdownChangePassword: false,
      alertConfirmBusiness: false,
      alertConfirmBankAccount: false,
      alertConfirmFlatrate: false,
      alertAdvanceSalesOrderNotify: false,
      numPageCountdown: 0,
      numPageCredit: 0,
      numPageBankAccount: 0,
      numPageFlatrate: 0,
      numAdvanceSalesOrderNotify: 0,
      onload: true,
      dayExpiration: 90,
      tenant: JSON.parse(Cookies.get('tenant')),
      user: JSON.parse(Cookies.get('user'))
    };
  },
  methods: {
    getCountdownChangePassword: async function () {
      this.onload = true;
      this.dayExpiration = this.tenant.password_policy;

      // แปลงวันที่ล่าสุดให้กลายเป็นวัตถุ Date
      const last = new Date(this.user.password_change_date);

      // หาวันปัจจุบัน
      const today = new Date();

      // หาผลต่างของวันที่ล่าสุดและวันปัจจุบัน
      const timeDiff = today.getTime() - last.getTime();

      // แปลงผลต่างเวลาที่ได้เป็นจำนวนวัน
      const daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));

      let countDown = this.dayExpiration - daysDiff;
      if (countDown <= 7) {
        if (countDown > 0) {
          this.countDownTimer = countDown;
        }
        this.alertCountdownChangePassword = true;
        this.numPageCountdown = 1;
      } else {
        this.alertCountdownChangePassword = false;
        this.numPageCountdown = 0;
      }
    },
    getBusinessInfoList: async function () {
      if (this.tenant.need_upgrade_business_info) {
        this.alertConfirmBusiness = true;
        this.numPageCredit = 1;
      } else {
        this.alertConfirmBusiness = false;
        this.numPageCredit = 0;
      }
    },
    getBankAccount: async function () {
      if (this.tenant.need_upgrade_bank_account) {
        this.alertConfirmBankAccount = true;
        this.numPageBankAccount = 1;
      } else {
        this.alertConfirmBankAccount = false;
        this.numPageBankAccount = 0;
      }
    },
    getFlatRate: async function () {
      if (this.tenant.need_upgrade_flat_rate) {
        this.alertConfirmFlatrate = true;
        this.numPageFlatrate = 1;
      } else {
        this.alertConfirmFlatrate = false;
        this.numPageFlatrate = 0;
      }
      // console.log(this.getFlatRate());
    },
    getAlertAdvanceSalesOrderNotify: async function () {
      if (this.tenant.need_upgrade_order_notification)  {
        this.alertAdvanceSalesOrderNotify = true;
        this.numAdvanceSalesOrderNotify = 1;
      } else {
        this.alertAdvanceSalesOrderNotify = false;
        this.numAdvanceSalesOrderNotify = 0;
      }
      this.onload = false;
    },
  },
  mounted() {
    this.getCountdownChangePassword();
    this.getBusinessInfoList();
    this.getAlertAdvanceSalesOrderNotify();
    this.getBankAccount();
    this.getFlatRate();
  },
  watch: {
    $refreshalert() {
      this.tenant = JSON.parse(Cookies.get('tenant'));
      this.getCountdownChangePassword();
      this.getBusinessInfoList();
      this.getAlertAdvanceSalesOrderNotify();
      this.getBankAccount();
      this.getFlatRate();
    },
  },
};
</script>
<style>
.button-next-prev-nas {
  margin-right: -30px;
  float: right;
  color: white;
}
.button-color-nas-next-prev {
  background-color: #ff7043;
  border: 0px;
  color: white;
}
.alert .carousel .left.carousel-control,
.alert .carousel .right.carousel-control {
  background-image: none;
  color: inherit;
  text-shadow: none;
  width: 2%;
  opacity: 1;
}

.alert .carousel .item {
  height: 30px;
}

.alert .carousel-caption-nas {
  padding: 0;
  bottom: 5px;
  left: 4%;
  text-align: left;
  text-shadow: none;
}
/*
remove margin-bottom
*/
.no-bottom-margin {
  margin-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/AlertCustomer.vue